import axios from 'axios';
import {backendHost} from '../../config';

export const postInvite = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/invite`, params);
};